module.exports = __webpack_public_path__ + "img/arm-propeller.dcbaadae.png";